/* Navigation shortcut only. Product availability and purchase stay native. */
if (!customElements.get('lm-purchase-shortcut')) {
  customElements.define('lm-purchase-shortcut', class extends HTMLElement {
    connectedCallback() {
      const target = document.getElementById(this.dataset.target);
      const form = target?.querySelector('.product-form__buttons');
      if (!target || !form || !('IntersectionObserver' in window)) return;
      this.observer = new IntersectionObserver(([entry]) => { this.hidden = entry.isIntersecting; }, { threshold: 0.1 });
      this.observer.observe(form);
    }
    disconnectedCallback() { this.observer?.disconnect(); }
  });
}
